module.exports = __webpack_public_path__ + "static/img/clothing_03.2bf8361.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/clothing_03.png
// module id = bXPQ
// module chunks = 0